
/**
 * CSV Parsing Utility
 * This file provides CSV parsing functionality for external strategy imports
 */

/**
 * Parse a CSV file into an array of objects
 * @param file The CSV file to parse
 * @returns A promise that resolves to an array of objects
 */
export const parseCsvFile = async (file: File): Promise<any[]> => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    
    reader.onload = (e) => {
      try {
        const text = e.target?.result as string;
        if (!text) {
          throw new Error('Failed to read file contents');
        }
        
        const lines = text.split('\n');
        const headers = lines[0].split(',').map(header => header.trim());
        
        const results = [];
        for (let i = 1; i < lines.length; i++) {
          const line = lines[i].trim();
          if (!line) continue; // Skip empty lines
          
          const values = line.split(',');
          const obj: Record<string, string> = {};
          
          for (let j = 0; j < headers.length; j++) {
            obj[headers[j]] = values[j]?.trim() || '';
          }
          
          results.push(obj);
        }
        
        resolve(results);
      } catch (error) {
        reject(new Error(`Failed to parse CSV file: ${error}`));
      }
    };
    
    reader.onerror = () => {
      reject(new Error('Error reading file'));
    };
    
    reader.readAsText(file);
  });
};
